/**
 * Customer "Mark Resolved" mutation. Hits POST /tickets/{n}/resolve.
 *
 * On success it invalidates the detail + list caches so the badge and
 * available-action buttons reflect the new state without manual reload.
 */
import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query";

import api from "@/lib/api";
import type { TicketResponse } from "@/types/api";

import { ticketDetailQueryKey } from "./useTicketDetail";

export function useResolveTicket(
  ticketNumber: number,
): UseMutationResult<TicketResponse, Error, void> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const response = await api.post<TicketResponse>(
        `/tickets/${ticketNumber}/resolve`,
      );
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ticketDetailQueryKey(ticketNumber),
      });
      void queryClient.invalidateQueries({ queryKey: ["tickets", "list"] });
    },
  });
}
